export function getSlideIndex(slides, slideID) {
  if (!Array.isArray(slides) || slides.length === 0) {
    return null;
  }

  const slideIndex = slides.findIndex(({ id }) => id === slideID);

  return slideIndex !== -1 ? slideIndex + 1 : null;
}
